<style src="./style.scss">
</style>

<script lang="ts">
  import { css } from "@emotion/css";
  import classNames from "classnames/bind";

  export let title;
  export let background;

  const className = classNames("badge");
</script>

<div class="{className}" style="background: {background}">{title}</div>
